import React, { useEffect, useState }  from 'react';
import PropTypes from "prop-types";
import axios from "axios";
import Swal from 'sweetalert2'
import { useFormik } from 'formik';
import * as yup from 'yup';
import Modal from 'react-bootstrap/Modal';

const validationSchema = yup.object({
    name: yup.string('Enter your name').required('Name is required')
});
export const AddCompetency = ({type, show, setShow, getList, editId, setEditId, userId, teamId=0, ...rest}) => {
    const handleClose = () => setShow(false);
    const initialValues = {
        id: editId,
        name: '',
        userId: userId,
        teamId: teamId
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: values => {
            handleSubmit(values);
        }
    });

    useEffect(() => {
        if(editId > 0){
            axios.get(`api/singleCompetency?id=${editId}`).then(res => {
                if(res.data.success){
                    formik.setFieldValue('id', res.data.data.id)
                    formik.setFieldValue('name', res.data.data.name)
                }
            })
        }
        else{
            formik.resetForm();
        }
    },[show]);

    const normalizeString = (value) => {
        if (!value) return '';
        return value.trim().replace(/\s+/g, ' ');
    };

    const handleSubmit = (values) =>{
        const cleanedValues = {
            ...values,
            name: normalizeString(values.name)
        };
        if(editId > 0){
            axios.put(`api/competencies/update`, cleanedValues).then(res => {
                setShow(false)
                if(res.data.success){                 
                    Swal.fire(res.data.message, '', 'success').then(result => {
                        formik.resetForm();
                        getList();                        
                    })
                } 
                else{
                    Swal.fire(res.data.message, '', 'error')
                }
            }).catch((error) => {
                setShow(false)
                Swal.fire(error.response.data.message, '', 'error')
            });
        }
        else{
            axios.post(`api/competencies/create`, cleanedValues).then(res => {
                setShow(false)
                if(res.data.success){
                    Swal.fire(res.data.message, '', 'success').then(result => {
                        formik.resetForm();
                        getList();
                    })                
                } 
                else{
                    Swal.fire(res.data.message, '', 'error')
                }
            }).catch((error) => {
                setShow(false)
                Swal.fire(error.response.data.message, '', 'error')
            });
        }        
    }

    const handlePopupClose = () => {
        formik.resetForm();
        handleClose()
    }
    return (
        <Modal show={show} onHide={handlePopupClose}>
            <Modal.Header closeButton>
            <Modal.Title>{type} Competency</Modal.Title>
            </Modal.Header>
                <form onSubmit={formik.handleSubmit}>
                    <Modal.Body> 
                        <div className="mb-3">
                            <label className="form-label" htmlFor="basic-icon-default-email">Competency Name</label>
                            <div className="input-group input-group-merge">
                                <input type="text" className="form-control" id="basic-icon-default-firstname" placeholder="Competency Name" aria-label="Competency Name" aria-describedby="basic-icon-default-fullname2"
                                name="name"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur} 
                                value={formik.values.name} />
                            </div>
                            {formik.touched.name && formik.errors.name && (
                                <div className="text-danger">{formik.errors.name}</div>
                            )}
                        </div> 
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal" onClick={handlePopupClose}>Close</button>
                        <button type="submit" className="btn btn-primary">{type == 'Add' ? 'Add' : 'Update'}</button>
                    </Modal.Footer>
                </form>
        </Modal>
    )
}
export default AddCompetency;
AddCompetency.propTypes = {
    type: PropTypes.string.isRequired,
    show: PropTypes.bool.isRequired,
    setShow: PropTypes.func.isRequired,
    // handleClose: PropTypes.func.isRequired    
};